import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { WorkOrderRawDto } from './work-order-raw-dto';
import { WorkOrderResponsibleUsersResultDto } from './work-order-responsible-users-result-dto';
const ɵ0 = () => WorkOrderRawDto, ɵ1 = () => KeyValueResultDto, ɵ2 = () => KeyValueResultDto, ɵ3 = () => KeyValueResultDto, ɵ4 = () => KeyValueResultDto, ɵ5 = () => KeyValueResultDto, ɵ6 = () => WorkOrderResponsibleUsersResultDto, ɵ7 = () => Date;
export class WorkOrderEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", WorkOrderRawDto)
], WorkOrderEditorResultDto.prototype, "workOrder", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], WorkOrderEditorResultDto.prototype, "statusList", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], WorkOrderEditorResultDto.prototype, "priorityList", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], WorkOrderEditorResultDto.prototype, "jobTypeList", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], WorkOrderEditorResultDto.prototype, "referenceTypeList", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], WorkOrderEditorResultDto.prototype, "serviceCodeList", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Array)
], WorkOrderEditorResultDto.prototype, "responsibleList", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Date)
], WorkOrderEditorResultDto.prototype, "createdDate", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
